import { getDepartment, getDepartments } from './departments-service'
import _ from 'lodash'

export function getStyles (departmentId, menuBlob) {
  return _.get(getDepartment(departmentId, menuBlob), 'styles', [])
}

export function getSizeId (departmentId, menuBlob) {
  return _.get(getStyleByKind(departmentId, true, menuBlob), 'id')
}

export function getStyleId (departmentId, menuBlob) {
  return _.get(getStyleByKind(departmentId, false, menuBlob), 'id')
}

export function getStyleByKind (departmentId, isSize, menuBlob) {
  return getStyles(departmentId, menuBlob).find(it => it.isSize === isSize)
}

export function getStyleOptionsByKind (departmentId, isSize, menuBlob) {
  return _.get(getStyleByKind(departmentId, isSize, menuBlob), 'options', [])
}

export function getStyle (departmentId, styleId, menuBlob) {
  return getStyles(departmentId, menuBlob).find(it => it.id === styleId)
}

export function getStyleOptions (departmentId, styleId, menuBlob) {
  return _.get(getStyle(departmentId, styleId, menuBlob), 'options', [])
}

export function getStyleOption (departmentId, styleId, optionId, menuBlob) {
  return getStyleOptions(departmentId, styleId, menuBlob).find(it => it.id === optionId)
}

export function getDepartmentHasStyleOptionsIndex (menuBlob) {
  return getDepartments(menuBlob).reduce((acc, department) => {
    const style = _.get(department, 'styles', []).find(next => !next.isSize)
    return {
      ...acc,
      [department.id]: !_.isEmpty(_.get(style, 'options'))
    }
  }, {})
}
